import React from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import CreateFoodOrderingManagement from "./CreateFoodOrderingManagement";
import ListFoodOrderingManagement from "./ListFoodOrderingManagement";
import EditFoodOrderingManagement from "./EditFoodOrderingManagement";

const FoodOrderingManagement = ({ match }) => (
  <div>
    <Route
      exact
      path={match.url}
      render={(props) => <ListFoodOrderingManagement {...props} />}
    />
    <Switch>
      <Route
        exact
        path={`${match.url}/add`}
        component={CreateFoodOrderingManagement}
      />
      <Route
        path={`${match.url}/:id`}
        render={(props) => <EditFoodOrderingManagement {...props} />}
      />
    </Switch>
  </div>
);

FoodOrderingManagement.propTypes = {
  match: PropTypes.object.isRequired,
};

export default FoodOrderingManagement;
